import "./App.css";
import "./fonts.css";

import { Navbar, Nav } from "react-bootstrap";
import { FaBomb } from "react-icons/fa6";
import { GiDinosaurRex } from "react-icons/gi";

/**
 * LegacyLayout Component
 *
 * Provides the legacy application shell with navbar and footer.
 * Used to wrap legacy route components while maintaining consistent UI.
 */
export function LegacyLayout({ user, children }) {
  return (
    <div className="App">
      <Navbar expand="lg" className="topFoot">
        <div
          id="navcontainer"
          style={{
            paddingLeft: "0.5rem",
            display: "flex",
            width: "100%",
            alignItems: "center",
          }}
        >
          <Navbar.Brand href="/" className="headings title">
            Problem Notes
          </Navbar.Brand>
        </div>
      </Navbar>

      <div className="primaryContainer">
        {children}
      </div>

      <Navbar
        sticky="bottom"
        className="underFoot headings"
        bg="dark"
        variant="dark"
        data-bs-theme="dark"
      >
        <Nav className="container-fluid ">
          <Nav.Link href={"/profile"}>
            <small>
              {user?.name || "Loading..."} ({user?.email || "..."})
            </small>
          </Nav.Link>

          <Nav.Item className="muted">{"hi there"}</Nav.Item>

          {/* Generated by GitHub Copilot */}
          <Nav.Link href={"/dino"} title="Dino Game">
            <GiDinosaurRex />
          </Nav.Link>
          {/* Generated by GitHub Copilot */}
          <Nav.Link href={"/minesweeper"} title="🎮 Minesweeper Easter Egg">
            <FaBomb />
          </Nav.Link>
        </Nav>
      </Navbar>
    </div>
  );
}

// Keep default export for backward compatibility (though not used anymore)
export default LegacyLayout;
